import { useTranslation } from "react-i18next";
import React, { useState } from "react";
import { createPortal } from "react-dom";
import { motion } from "framer-motion";

type DataGridFooterSelectionProps = React.HTMLAttributes<HTMLDivElement> & {
  SelectionModel: (string | number)[];
};

export default function DataGridFooterSelection({
  SelectionModel,
  ...props
}: DataGridFooterSelectionProps) {
  const { t } = useTranslation();
  const [showFooterSelectionCount, setShowFooterSelectionCount] =
    useState<boolean>(false);

  const columnHeaders = document.querySelector(".MuiDataGrid-columnHeaders");

  return (
    <>
      {SelectionModel.length > 0 &&
        (() => {
          return columnHeaders
            ? createPortal(
                <motion.div
                  className="absolute bg-[#F4F8FB] z-10 w-full ml-[50px] pl-2"
                  initial={{ opacity: 1, y: 0 }}
                  animate={{ opacity: 1, y: 0 }}
                  exit={{ opacity: 0, y: -20 }}
                  onViewportLeave={() => {
                    setShowFooterSelectionCount(true);
                  }}
                  onViewportEnter={() => {
                    setShowFooterSelectionCount(false);
                  }}
                  ref={(el) => {
                    if (el) {
                      const rect = el.getBoundingClientRect();
                      const inView =
                        rect.top >= 0 &&
                        rect.bottom <=
                          (window.innerHeight ||
                            document.documentElement.clientHeight);
                      if (!inView) {
                        setShowFooterSelectionCount(true);
                      }
                    }
                  }}
                >
                  <div className="sticky top-0 flex">
                    {t("checked", { checkCount: SelectionModel.length })}
                  </div>
                </motion.div>,
                columnHeaders
              )
            : null;
        })()}
      {showFooterSelectionCount && (
        <>
          <span className="text-gray-700 text-sm hidden sm:inline">|</span>
          <span {...props} className="text-gray-700 text-sm">
            {t("checked", { checkCount: SelectionModel.length })}
          </span>
        </>
      )}
    </>
  );
}
